import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

const classes = {
    stateHidden: 'h-visuallyhidden',
    loadMoreButton: 'js-load-more-button',
    loadMoreBar: 'js-load-more-bar',
    activeState: 'm-customer-lounge-project--active',
    selectLink: 'js-o-customer-lounge-project-teaser__sort',
    projectBody: 'js-m-customer-lounge-project__body',
    projectHead: 'js-m-customer-lounge-project__head',
    collapseHide: 'js-m-customer-lounge-project__collapse-hide',
    teaserContainer: 'o-customer-lounge-project-teaser__container',
    loadingBar: 'o-customer-lounge-project-teaser__loading-wrapper',
    showLoadingBar: 'state-loading-wrapper--shown'
};

@createModule('CustomerLoungeProjectTeaser')
/**
 * customer-lounge-project-teaser module implementation.
 */
export class CustomerLoungeProjectTeaser extends TerrificSpec {
    $ctx: JQuery;
    isOpen: boolean;

    start(resolve: Function) {
        this.$ctx = $(this._ctx);

        this.initAccordion();

        // init teaser data
        this.getTeaserData();

        this.$ctx.find(`.${classes.loadMoreButton}`).on("click", this.loadMore.bind(this));

        this.$ctx.find(`.${classes.selectLink}`).on('change', (ev: Event) => this.sorting());

        resolve();
    }

    getTeaserData() {
        this.lockLoadMoreButton();
        this.showLoadingBar();

        const apiEndpoint = this.$ctx.data("api-endpoint");
        const pageNumber = this.$ctx.data("page-number");
        const loungeName = this.$ctx.data("lounge-name");
        const datasource = this.$ctx.data("datasource");

        const sortingValue = this.$ctx.find(`.${classes.selectLink}`).find("option:selected").val() as string;
        const sortingProperties = sortingValue.split(",");
        const sortBy = sortingProperties[0];
        const sortOrder = sortingProperties[1];

        $.ajax({
            type: 'POST',
            url: apiEndpoint,
            dataType: 'html',
            data:
            {
                pageNumber: pageNumber,
                sortBy: sortBy,
                sortOrder: sortOrder,
                loungeName: loungeName,
                datasource: datasource
            },
            success: (response: any) => {
                console.log("get teaser data success");

                let container = this.$ctx.find(`.${classes.teaserContainer}`);
                container.append(response);

                let data = container.find("script[type='application/json']");

                if (data.length > 0) {
                    let json = data[0].innerHTML;
                    let jsonData = JSON.parse(json);

                    if (jsonData.totalNumber > 0) {
                        this.updatePageNumber(jsonData.pageNumber + 1);
                        this.updateLoadMoreButton(jsonData.enableLoadMore);

                    } else {
                        //this.updateNoResult();
                    }
                    data.remove();
                } else {
                    //this.updateNoResult();
                }

            },
            complete: () => {
                this.hideLoadingBar();
            },
            error: () => {
                console.log("get project teaser data error");
            }
        });
    }

    loadMore() {
        this.getTeaserData();
    }


    updateLoadMoreButton(enable: boolean) {
        if (enable) {
            this.unlockLoadMoreButton();
        } else {
            this.lockLoadMoreButton();
        }
    }

    lockLoadMoreButton() {
        this.$ctx.find(`.${classes.loadMoreBar}`).addClass(`${classes.stateHidden}`);
    }

    unlockLoadMoreButton() {
        this.$ctx.find(`.${classes.loadMoreBar}`).removeClass(`${classes.stateHidden}`);
    }

    showLoadingBar() {
        this.$ctx.find(`.${classes.loadingBar}`).addClass(`${classes.showLoadingBar}`);
    }

    hideLoadingBar() {
        this.$ctx.find(`.${classes.loadingBar}`).removeClass(`${classes.showLoadingBar}`);
    }

    updatePageNumber(pageNumber: number) {
        this.$ctx.data("page-number", pageNumber);
    }

    sorting() {
        this.$ctx.find(`.${classes.teaserContainer}`).empty();
        this.updatePageNumber(0);
        this.getTeaserData();
    }

    initAccordion() {
        $(document).on("click",
            `.${classes.projectHead}`,
            function () {
                $(this).parent().toggleClass(`${classes.activeState}`);
                $(this).parent().find(`.${classes.projectBody}`).slideToggle();
            });
        $(document).on('click',
            `.${classes.collapseHide}`,
            function () {
                $(this).parent().parent().parent().removeClass(classes.activeState);
                $(this).parent().parent().slideUp();
            });
    }

    stop() { }
} 
